(function () {
  'use strict';

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  /* ---------- shop the look hotspots ---------- */

  function buildLook() {
    var dots = document.querySelectorAll('.pl-dot');
    var panel = document.getElementById('plLookPanel');
    if (!dots.length || !panel) return;

    dots.forEach(function (d) {
      d.setAttribute('aria-label', d.getAttribute('data-t') || 'פריט');
      d.addEventListener('click', function () {
        dots.forEach(function (x) { x.classList.remove('is-on'); });
        d.classList.add('is-on');
        var t = d.getAttribute('data-t') || '';
        var h = d.getAttribute('data-h') || '/collections/all';
        panel.innerHTML =
          '<h3>' + esc(t) + '</h3>' +
          '<a href="' + h + '">לצפייה בכל האפשרויות</a>';
      });
    });
  }

  /* ---------- single-select filters ----------
     Shopify renders list filters as checkboxes, so a shopper can stack
     Nike + Dior + Adidas and get a meaningless mixed grid. Brand and product
     type are forced to radio behaviour.

     Two layers, because the theme builds its request from its own snapshot
     and does not necessarily re-read the DOM:
       1. DOM  — clear sibling boxes on pointerdown, before anything toggles.
       2. URL  — collapse duplicate params on pushState / replaceState /
                 fetch, keeping the value the shopper just added.
     Layer 2 is what actually guarantees the result. */

  var SINGLE = ['filter.p.vendor', 'filter.p.product_type'];
  var applied = {};

  function snapshot(search) {
    var sp = new URLSearchParams(search || '');
    SINGLE.forEach(function (k) { applied[k] = sp.getAll(k); });
  }

  function collapse(raw) {
    var u;
    try { u = new URL(raw, location.origin); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;

    var changed = false;
    SINGLE.forEach(function (k) {
      var vals = u.searchParams.getAll(k);
      if (vals.length < 2) {
        if (vals.length) applied[k] = vals;
        return;
      }
      var prev = applied[k] || [];
      var fresh = vals.filter(function (v) { return prev.indexOf(v) === -1; });
      var keep = fresh.length ? fresh[0] : vals[vals.length - 1];
      u.searchParams.delete(k);
      u.searchParams.append(k, keep);
      applied[k] = [keep];
      changed = true;
    });

    return changed ? u.pathname + u.search + u.hash : null;
  }

  function resolveBox(t) {
    if (!t || !t.closest) return null;
    if (t.tagName === 'INPUT') return t;
    var lab = t.closest('label');
    if (!lab) return null;
    if (lab.control) return lab.control;
    if (lab.htmlFor) return document.getElementById(lab.htmlFor);
    return lab.querySelector('input[type="checkbox"]');
  }

  function isSingle(el) {
    return el && el.tagName === 'INPUT' && el.type === 'checkbox' &&
           SINGLE.indexOf(el.name) !== -1;
  }

  function clearPeers(el) {
    var peers = document.querySelectorAll(
      'input[type="checkbox"][name="' + el.name + '"]'
    );
    for (var i = 0; i < peers.length; i++) {
      if (peers[i] !== el && peers[i].checked) peers[i].checked = false;
    }
  }

  function onDown(e) {
    var el = resolveBox(e.target);
    if (!isSingle(el) || el.checked) return;
    clearPeers(el);
  }

  function singleSelect() {
    snapshot(location.search);

    document.addEventListener('pointerdown', onDown, true);
    document.addEventListener('click', onDown, true);

    ['pushState', 'replaceState'].forEach(function (m) {
      var orig = history[m];
      history[m] = function (state, title, url) {
        if (typeof url === 'string') {
          var fixed = collapse(url);
          if (fixed) url = fixed;
        }
        return orig.call(this, state, title, url);
      };
    });

    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        try {
          if (typeof input === 'string') {
            var f1 = collapse(input);
            if (f1) input = f1;
          } else if (input && input.url) {
            var f2 = collapse(input.url);
            if (f2) input = new Request(f2, input);
          }
        } catch (e) {}
        return origFetch.call(this, input, init);
      };
    }

    window.addEventListener('popstate', function () {
      snapshot(location.search);
    });

    var onLoadFix = collapse(location.pathname + location.search);
    if (onLoadFix) location.replace(onLoadFix);
  }

  function init() {
    try { buildLook(); } catch (e) {}
    try { singleSelect(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
